// Quick choices for the mileage purpose field reuse the trips already stored in
// the mileage log. Nothing new is persisted: the log is the history signal, so a
// purpose becomes a suggestion the moment a trip using it is saved.
//
// Business and private trips keep separate suggestion lists. A purpose written
// for a deductible work trip is not a sensible default for private driving, and
// the private placeholder should not leak into the business list.
(function initMileagePurposeQuickChoices(global) {
  const MAX_CHOICES = 4;

  const safeArray = (value) => Array.isArray(value) ? value : [];
  const cleanText = (value) => String(value == null ? '' : value).trim();
  const normalizeText = (value) => cleanText(value)
    .toLocaleLowerCase('nb-NO')
    .replace(/\s+/g, ' ');
  const tripUsageType = (trip) =>
    (trip?.usageType === 'private' || trip?.privateUse === true) ? 'private' : 'business';
  const wantedUsageType = (tripType) => tripType === 'private' ? 'private' : 'business';
  const tripTimestamp = (trip) => cleanText(trip?.updatedAt || trip?.date || trip?.createdAt);

  const build = ({ trips, tripType, limit } = {}) => {
    const wanted = wantedUsageType(tripType);
    const max = Number.isFinite(limit) && limit > 0 ? Math.min(limit, MAX_CHOICES) : MAX_CHOICES;
    const history = new Map();
    safeArray(trips)
      .filter((trip) => tripUsageType(trip) === wanted)
      .forEach((trip) => {
        const purpose = cleanText(trip?.purpose);
        const key = normalizeText(purpose);
        if (!key) return;
        const lastUsedAt = tripTimestamp(trip);
        const current = history.get(key) || { purpose, count: 0, lastUsedAt: '' };
        current.count += 1;
        // The most recent trip owns the spelling, so a corrected capitalisation
        // replaces the older variant instead of adding a second pill.
        if (lastUsedAt >= current.lastUsedAt) {
          current.purpose = purpose;
          current.lastUsedAt = lastUsedAt;
        }
        history.set(key, current);
      });
    return [...history.values()]
      .sort((left, right) =>
        right.count - left.count || String(right.lastUsedAt).localeCompare(String(left.lastUsedAt)))
      .slice(0, max);
  };

  const isSamePurpose = (left, right) => {
    const normalized = normalizeText(left);
    return !!normalized && normalized === normalizeText(right);
  };

  global.PlummeMileagePurposeQuickChoices = { MAX_CHOICES, build, isSamePurpose };
})(typeof window !== 'undefined' ? window : globalThis);
